<template>
  <unknown-error-view />
</template>

<script>
  /*unknownErrorView view wrapper*/

  // components
  import unknownErrorView from '../../views/unknownErrorView/unknownErrorView';

  export default {
    name: "unknownError",
    components: {
      unknownErrorView,
    }
  }
</script>

